import React, {useEffect} from 'react'
import UiInputText from "../components/Form/UiInputText";
import UiInputList from "../components/Form/UiInputList";
import UiInputNumberInteger from "../components/Form/UiInputNumberInteger";
import UiInputSuggest from "../components/Form/UiInputSuggest";
import Form from "../components/Form/Form";
import {useForm, FormProvider} from "react-hook-form";
import WindowBody from '../components/Window/WindowBody';
import WindowFooter from '../components/Window/WindowFooter';
import { UiButton } from '../components/UiButton';

const papelList = [
    { id: 'empresa', title: 'Empresa' },
    { id: 'socio', title: 'Sócio administrador' },
    { id: 'instalador', title: 'Instalador' },
    { id: 'testemunha', title: 'Testemunha' },
];

/**
 * Um espaço de assinatura do modelo. Chega pela ação "Espaços de assinatura" do grid
 * de modelos.
 *
 * As medidas são em milímetro, com origem no canto superior esquerdo do A4, e o
 * rótulo diz isso: sem a unidade ninguém sabe se 40 é milímetro, ponto ou pixel.
 *
 * Modelo publicado não tem espaço alterado: o servidor recusa e diz para criar uma
 * versão nova. A tela avisa antes, para o operador não digitar em vão.
 */
export default function ContratoModeloEspacoForm(props: any){
    const methods = useForm({
        defaultValues: props.data || { papel: 'instalador', pagina: 1, x: 20, y: 230, largura: 80, altura: 20 }
    });
    const { handleSubmit, reset, watch } = methods;

    const publicado = !!watch('modeloPublicado');
    const publicadoEm = watch('publicadoEm');

    useEffect(() => {
        if (props.data) {
            reset(props.data);
        }
    }, [props.data, reset]);

    return (
        <FormProvider {...methods}>
            <Form onSubmit={handleSubmit(props.triggerSubmit)} methods={methods}>
                <WindowBody>
                    {publicado && (
                        <div className="alert alert-warning">
                            <strong>Modelo publicado{typeof publicadoEm === 'string' ? ` em ${publicadoEm}` : ''}.</strong>{' '}
                            Este espaço não pode ser alterado: os contratos gerados apontam para esta versão.
                            Use <strong>Nova versão</strong> no grid de modelos e edite os espaços da nova.
                        </div>
                    )}

                    <div className="row">
                        <UiInputSuggest size={12} name="modelo" router="uncontratomodelo" idField="id" titleField="nome" label="Modelo de contrato"/>
                        <UiInputText size={12} name="nome" label="Nome do espaço" placeholder="Assinatura da CONTRATADA"/>
                        <UiInputList size={8} name="papel" list={papelList} idField="id" titleField="title" label="Papel esperado"/>
                        <UiInputNumberInteger size={4} name="pagina" label="Página"/>
                    </div>

                    <fieldset>
                        <legend>Posição no A4, em milímetro</legend>
                        <div className="row">
                            <div className="col-lg-12">
                                <p className="text-muted small">
                                    Origem no canto superior esquerdo da página (A4 = 210 x 297 mm). É o lugar
                                    fixo do modelo; a posição de fato usada fica gravada na assinatura.
                                </p>
                            </div>
                            <UiInputNumberInteger size={6} name="x" label="X, da esquerda (mm)"/>
                            <UiInputNumberInteger size={6} name="y" label="Y, do topo (mm)"/>
                            <UiInputNumberInteger size={6} name="largura" label="Largura (mm)"/>
                            <UiInputNumberInteger size={6} name="altura" label="Altura (mm)"/>
                        </div>
                    </fieldset>
                </WindowBody>

                <WindowFooter>
                    <UiButton variant="secondary" onClick={props.triggerClose}>Fechar</UiButton>
                    <UiButton variant="primary" type="submit">Salvar</UiButton>
                </WindowFooter>
            </Form>
        </FormProvider>
    )
}
